import { View, Modal } from "react-native";
import React from "react";
import { Layout, Text } from "@ui-kitten/components";
import { SafeAreaView } from "react-native-safe-area-context";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import Button from "components/Button";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import NewMemberForm from "components/NewMemberForm";
import { BuyFlowUser } from "features/types";
import { useAppSelector } from "hooks/useAppSelector";
import { ActionSheetProvider } from "@expo/react-native-action-sheet";
import Toast from "react-native-toast-message";
import toastConfig from "config/toastConfig";
import { getWidth } from "components/MainContainer";

interface EditMemberModalProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  handleNewMemberSubmit: (values: BuyFlowUser) => void;
}

const EditMemberModal: React.FC<EditMemberModalProps> = ({
  visible,
  setVisible,
  handleNewMemberSubmit,
}) => {
  const { selectedPlanPackage, editingUser, editingChild } = useAppSelector(
    (state) => state.buyFlow
  );

  if (!selectedPlanPackage) return null;
  return (
    <Modal visible={visible} style={{ flex: 1 }}>
      <ActionSheetProvider>
        {/* had trouble making the modal scroll so use react-native modal instead */}

        <Layout
          style={{
            flex: 1,
            padding: 20,
            backgroundColor: "rgba(0,0,0,0.5)",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SafeAreaView />
          <KeyboardAwareScrollView
            stickyHeaderIndices={[0]}
            style={{
              backgroundColor: "white",
              borderRadius: 10,
              width: getWidth(),
            }}
          >
            <View
              style={{
                marginBottom: 15,
                padding: 15,
                backgroundColor: "white",
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Text category="h6" style={{ fontSize: 25 }}>
                  {editingUser.email !== "" ? "Edit" : "Add"} Member
                </Text>
                <Button appearance="ghost" onPress={() => setVisible(false)}>
                  {() => (
                    <MaterialCommunityIcons
                      name="close"
                      size={24}
                      color="black"
                    />
                  )}
                </Button>
              </View>
            </View>
            <View style={{ padding: 15 }}>
              <Text category="h6">{selectedPlanPackage.name}</Text>
              <NewMemberForm
                onSubmit={handleNewMemberSubmit}
                initialValues={editingUser}
                editingChild={editingChild}
              />
            </View>
          </KeyboardAwareScrollView>
        </Layout>
      </ActionSheetProvider>
      <Toast config={toastConfig} />
    </Modal>
  );
};

export default EditMemberModal;
